// ============ EDITA AQUÍ ============

// Host
export const HOST_NAME = 'Chale Rodriguez';
export const HOST_FIRST = 'Chale';
export const BRAND = 'Chale Rodriguez';

// Barra superior
export const HEADER_TITLE = 'Llamada 1:1 con Chale';
export const HEADER_LOGO_URL = ''; // opcional: logo/firma en blanco (PNG). Vacío = ícono por defecto

// Etiqueta de disponibilidad (la cuenta regresiva cierra el domingo 11:59 PM de la semana actual)
export const WEEK_LABEL = 'Cupos de esta semana: lunes a sábado';

// Imágenes (URLs). Vacío = placeholder
export const HOST_PHOTO_URL = 'https://cdn.magicpatterns.com/uploads/prAkqdEtahLTrtkZVVR2XY/Screenshot_2026-10-13_at_6.18.32_PM.png'; // foto de Chale
export const COLLAGE_URL = '';      // collage de Chale trabajando (sección "Hoy…")
export const AVATAR_URLS: string[] = []; // fotos reales de su comunidad/equipo (con permiso)

// Datos reales para los badges junto a la foto
export const BADGE_LEFT = { title: 'Instagram', value: '9K+' };
export const BADGE_RIGHT = { title: 'Desde', value: 'Miami' };

// Video de la página de agenda (explicativo 4–6 min)
// OPCIÓN A: link de YouTube (no listado). Arranca en silencio; al hacer clic se activa el sonido.
export const TYP_YOUTUBE_URL = '';
// OPCIÓN B: embed de Bunny/Vimeo. Se usa solo si TYP_YOUTUBE_URL está vacío.
export const TYP_VIDEO_EMBED_URL = '';
export const TYP_VIDEO_POSTER_URL = '';

// Calendario de GoHighLevel (src del embed). Configura la redirección post-reserva a: <dominio>/#/confirmada
export const GHL_CALENDAR_EMBED_URL = '';

// Meta Pixel
export const META_PIXEL_ID = 'YOUR_PIXEL_ID';

// Webhook GHL (Inbound Webhook). Se envía en el paso 1 (datos) y en el paso 2 (respuestas).
export const LEAD_WEBHOOK_URL = '';

// SEO y vistas previas al compartir el link
export const SITE_URL = '';      // dominio final, ej: https://chalerodriguez.com (para el canonical). Vacío = se omite
export const OG_IMAGE_URL = '';  // imagen para WhatsApp/Facebook/Instagram, 1200x630 px. Vacío = se omite
export const INSTAGRAM_URL = ''; // perfil de Instagram de Chale (datos estructurados). Vacío = se omite

// Links y footer
export const WHATSAPP_URL = 'https://wa.me/1XXXXXXXXXX';
export const CONTACT_EMAIL = 'info@tudominio.com';
export const PRIVACY_URL = '#';
